/**
 * Text made safe to put in HTML: for markup built as strings, such as the
 * cells DataTables renders as HTML (order list). React escapes on its own.
 * null/undefined become "".
 */
export const escapeHtml = (value) => String(value == null ? "" : value)
  .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
  .replace(/"/g, "&quot;").replace(/'/g, "&#39;");

export default escapeHtml;
